import i18n from "@/core/i18n/i18n";
import { useStepDisplay } from "@/core/composables/useStepDisplay";

const { t } = i18n.global;
const { getStepDisplayNumber } = useStepDisplay();

export function findInvalidStepFilterIndex(steps: any[]): string[] {
  const messages: string[] = [];

  function helper(list: any[], context?: string) {
    list.forEach((step: any, i: number) => {
      if (!step.type && Object.prototype.hasOwnProperty.call(step, "filter")) {
        const f = step.filter;
        if (Array.isArray(f) && f.some((cond: any) => !cond.condition)) {
          if (context) {
            const stepNum = getStepDisplayNumber(step.index, step.stepNumber);
            messages.push(`${context} – ${t("Common.Step")} ${stepNum}`);
          } else {
            const stepNum = getStepDisplayNumber(i, step.stepNumber);
            messages.push(`${t("Common.Step")} ${stepNum}`);
          }
        }
      }
      if (Array.isArray(step.routes)) {
        step.routes.forEach((route: any) => {
          const condName = route.name || t("Common.Condition");
          helper(route.steps, condName);
        });
      }
      if (Array.isArray(step.steps)) {
        helper(step.steps, context);
      }
    });
  }

  helper(steps);
  return messages;
}
